const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export default function SchedulingPage() {
  return (
    <div className="h-full overflow-y-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Scheduling</h1>
        <button className="px-4 py-2 rounded-full bg-accent text-accent-foreground text-sm font-semibold hover:opacity-90 transition-opacity">
          + New Task
        </button>
      </div>

      <div className="rounded-2xl bg-surface border border-border overflow-hidden">
        <div className="grid grid-cols-7 border-b border-border">
          {DAYS.map((day) => (
            <div key={day} className="p-3 text-center text-xs font-medium text-muted">
              {day}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-7 divide-x divide-border min-h-[320px]">
          {DAYS.map((day) => (
            <div key={day} className="p-2 space-y-1.5">
              {day === 'Mon' && (
                <div className="rounded-lg bg-accent/15 border border-accent/30 px-2 py-1">
                  <p className="text-xs font-medium text-accent truncate">Patrol route</p>
                  <p className="text-[10px] text-muted">09:00</p>
                </div>
              )}
              {day === 'Wed' && (
                <div className="rounded-lg bg-accent/15 border border-accent/30 px-2 py-1">
                  <p className="text-xs font-medium text-accent truncate">Inspection</p>
                  <p className="text-[10px] text-muted">14:00</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
